// removed by extract-text-webpack-plugin
module.exports = {"projectSummary":"qWlBMHzGSXfpUlooKp39_","summary":"_3xpF2DdGCXZ-WMwWS1T3bM","name":"_1U2FHXtwT-4W1-EXn-cXi8","shortDescription":"_3xE5-AcIjVV3j2SgFzqCrB","address":"_3WKuY4hHqrCwLPpiDEIUjm","price":"_13JZWMzYi9d-KyA5mSDhnq","about":"EkZfbtT6ewK2KNI1xuSgo","logo":"_2iBqYBx4GX6fA5RlEb8_sM"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ProjectDetailedInfo/ProjectSummary/ProjectSummary.scss
// module id = 1709
// module chunks = 0